import { ArrowsUpDownIcon } from '@heroicons/react/24/outline';
import type { SortingState } from '@tanstack/react-table';
import { Select } from './forms';
import { FilterWrapper } from './product-table/filters/filter-wrapper';
import { ToolbarPopover } from './toolbar/popover';

export type SortColumnOption = {
  id: string;
  label: string;
  hideDirection?: boolean;
};

export type SortPopoverProps = {
  sorting: SortingState;
  onSortingChange: (sorting: SortingState) => void;
  sortColumnOptions: SortColumnOption[];
};

export function SortPopover({ sorting, onSortingChange, sortColumnOptions }: SortPopoverProps) {
  const currentSort = sorting[0];
  const currentColumnId = currentSort?.id ?? sortColumnOptions[0]?.id ?? '';
  const isDescending = currentSort?.desc ?? true;

  const currentOption = sortColumnOptions.find((o) => o.id === currentColumnId);
  const showDirection = !currentOption?.hideDirection;

  const handleColumnChange = (columnId: string) => {
    onSortingChange([{ id: columnId, desc: isDescending }]);
  };

  const handleDirectionChange = (desc: boolean) => {
    onSortingChange([{ id: currentColumnId, desc }]);
  };

  return (
    <ToolbarPopover icon={<ArrowsUpDownIcon className="size-5" />} label="Sort" minWidth="min-w-80">
      <FilterWrapper label="Sort by">
        <Select<string>
          value={currentColumnId}
          onChange={handleColumnChange}
          options={sortColumnOptions.map((option) => ({ value: option.id, label: option.label }))}
        />
      </FilterWrapper>

      {showDirection && (
        <FilterWrapper label="Order">
          <div className="flex items-center space-x-4">
            <label className="flex items-center">
              <input
                type="radio"
                name="direction"
                value="asc"
                checked={!isDescending}
                onChange={() => handleDirectionChange(false)}
                className="mr-2"
              />
              <span className="text-sm">Ascending</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="direction"
                value="desc"
                checked={isDescending}
                onChange={() => handleDirectionChange(true)}
                className="mr-2"
              />
              <span className="text-sm">Descending</span>
            </label>
          </div>
        </FilterWrapper>
      )}
    </ToolbarPopover>
  );
}
